import { lazy, Suspense } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ArrowTrendingUpIcon, ChartBarIcon, CurrencyDollarIcon, PresentationChartLineIcon, ShieldCheckIcon, StarIcon, UserCircleIcon } from '@heroicons/react/24/outline'
import { RouteElement } from 'interfaces/_common'
import { SubMenuTabs } from '../common'
import RouteKeys from 'constants/route-keys'
import { PagePreloader } from '../../../components/pagePreloader'

const DislikeReport = lazy(() => import('./DislikeReport'))
const RatingReport = lazy(() => import('./RatingReport'))
const SubscriptionReport = lazy(() => import('./SubscriptionReport'))
const SubscriptionHealthReport = lazy(() => import('./SubscriptionHealthReport'))
const UserPlanReport = lazy(() => import('./UserPlanReport'))
const AcquisitionReport = lazy(() => import('./AcquisitionReport'))
const AcquisitionFunnelReport = lazy(() => import('./AcquisitionFunnelReport'))
const ConversionFunnelReport = lazy(() => import('./ConversionFunnelReport'))
const RevenueMonetizationReport = lazy(() => import('./RevenueMonetizationReport'))
const PaymentOrderReport = lazy(() => import('./PaymentOrderReport'))

const _routes: RouteElement[] = [
  {
    route: 'payment-order-report',
    title: 'Payment Order Report',
    key: RouteKeys.PAYMENT_ORDER_REPORT,
    component: PaymentOrderReport,
    icon: CurrencyDollarIcon,
    display: true
  },
  {
    route: 'dislike-report',
    title: 'Dislike Report',
    key: RouteKeys.DISLIKE_REPORT,
    component: DislikeReport,
    icon: ChartBarIcon,
    display: true
  },
  {
    route: 'rating-report',
    title: 'Rating Report',
    key: RouteKeys.RATING_REPORT,
    component: RatingReport,
    icon: StarIcon,
    display: true
  },
  {
    route: 'payment-reconciliation',
    title: 'Payment Reconciliation',
    key: RouteKeys.USER_PLAN_REPORT,
    component: UserPlanReport,
    icon: UserCircleIcon,
    display: true
  },
  {
    route: 'acquisition-report',
    title: 'Acquisition Report',
    key: RouteKeys.ACQUISITION_REPORT,
    component: AcquisitionReport,
    icon: PresentationChartLineIcon,
    display: true
  },
  {
    route: 'acquisition-funnel-report',
    title: 'Acquisition Funnel Report',
    key: RouteKeys.ACQUISITION_FUNNEL_REPORT,
    component: AcquisitionFunnelReport,
    icon: PresentationChartLineIcon,
    display: true
  },
  {
    route: 'subscription-report',
    title: 'Subscription Report',
    key: RouteKeys.SUBSCRIPTION_REPORT,
    component: SubscriptionReport,
    icon: ChartBarIcon,
    display: true
  },
  {
    route: 'subscription-health-report',
    title: 'Subscription Health Report',
    key: RouteKeys.SUBSCRIPTION_HEALTH_REPORT,
    component: SubscriptionHealthReport,
    icon: ShieldCheckIcon,
    display: true
  },
  {
    route: 'conversion-funnel-report',
    title: 'Conversion Funnel Report',
    key: RouteKeys.CONVERSION_FUNNEL_REPORT,
    component: ConversionFunnelReport,
    icon: ArrowTrendingUpIcon,
    display: true
  },
  {
    route: 'revenue-monetization-report',
    title: 'Revenue Monetization Report',
    key: RouteKeys.REVENUE_MONETIZATION_REPORT,
    component: RevenueMonetizationReport,
    icon: CurrencyDollarIcon,
    display: true
  }
  //  {
  //   route: 'conversion-report',
  //   title: 'Conversion Report',
  //   key: RouteKeys.CONVERSION_REPORT,
  //   component: ConversionReport,
  //   icon: ArrowTrendingUpIcon,
  //   display: true
  // },
  // {
  //   route: 'engagement-report',
  //   title: 'Engagement Report',
  //   key: RouteKeys.ENGAGEMENT_REPORT,
  //   component: EngagementReport,
  //   icon: ChatBubbleLeftRightIcon,
  //   display: true
  // },
  // {
  //   route: 'monetization-report',
  //   title: 'Monetization Report',
  //   key: RouteKeys.MONETIZATION_REPORT,
  //   component: MonetizationReport,
  //   icon: CurrencyDollarIcon,
  //   display: true
  // }
]

const Reports = () => {
  return (
    <div>
      <SubMenuTabs _routes={_routes} />
      <div className="p-3">
        <Routes>
          <Route 
            path='' 
            element={<Navigate to={_routes[0].route} replace />} 
          />
          {_routes.map(route => {
            const ReportComponent = route.component

            return (
              <Route
                path={route.route}
                key={'report-' + route.route}
                element={
                  <Suspense fallback={<PagePreloader />}>
                    <ReportComponent />
                  </Suspense>
                }
              />
            )
          })}
          <Route path="user-plan-report" element={<Navigate to="payment-reconciliation" replace />} />
        </Routes>
      </div>
    </div>
  )
}

export default Reports
